import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import ReactPaginate from "react-paginate";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { postData } from "../../../utility/Utility";
import Swal from "sweetalert2";
import CustomLoader from "../../../Components/CustomLoader/CustomLoader";

function CSVLeadList() {
    const navigate = useNavigate();
    const [csvLeads, setCsvLeads] = useState([]);
    const [loading, setLoading] = useState(false);
    const [searchTerm, setSearchTerm] = useState("");
    const [startDate, setStartDate] = useState("");
    const [endDate, setEndDate] = useState("");
    const [currentPage, setCurrentPage] = useState(0);
    const [totalPages, setTotalPages] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [userData, setUserData] = useState({});

  

    const fetchCSVLeads = async (page = 1, search = "", limit = rowsPerPage, startDate = "", endDate = "") => {
        setLoading(true);
        try {
            const response = await postData("api/csv-leads/", {
                page,
                limit,
                search,
                ...(startDate && { startDate }),
                ...(endDate && { endDate })
            });

            if (response?.success) {
                setCsvLeads(response.data || []);
                setTotalPages(response.pagination?.pages || 0);
            } else {
                toast.error(response.message || "Failed to fetch CSV leads");
                setCsvLeads([]);
            }
        } catch (error) {
            toast.error("Error fetching CSV leads");
            console.error("Fetch CSV leads error:", error);
            setCsvLeads([]);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchCSVLeads(currentPage + 1, searchTerm, rowsPerPage, startDate, endDate);
    }, []);

    const handlePageChange = ({ selected }) => {
        setCurrentPage(selected);
        fetchCSVLeads(selected + 1, searchTerm, rowsPerPage, startDate, endDate);
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        setCurrentPage(0);
        fetchCSVLeads(1, searchTerm, rowsPerPage, startDate, endDate);
    };

    const handleReset = () => {
        setSearchTerm("");
        setStartDate("");
        setEndDate("");
        setCurrentPage(0);
        fetchCSVLeads(1, "", rowsPerPage, "", "");
    };

    const handleRowsPerPageChange = (e) => {
        const newLimit = parseInt(e.target.value);
        setRowsPerPage(newLimit);
        setCurrentPage(0);
        fetchCSVLeads(1, searchTerm, newLimit, startDate, endDate);
    };


     const fetchProfileData = async () => {
        try {
          const response = await postData('api/admin/profile');
          if (response?.success) {
            // Store both user data and permission data
            setUserData({
              ...response.data,
              role: response.data?.role,
              permission: response.permission?.permission || []
            });
          }
          console.log("Profile Data Response:", response);
        } catch (error) {
          console.error('Error fetching profile data:', error);
        }
      }

      useEffect(() => {
        fetchProfileData();
      }, []);   

    return (
        <div className="content-page">
            <ToastContainer position="top-right" autoClose={3000} />
            <CustomLoader loading={loading} />
            <div className="content">
                <div className="container-fluid">
                    <div className="py-3 d-flex align-items-sm-center flex-sm-row flex-column justify-content-between">
                        <div className="flex-grow-1">
                            <h4 className="fs-18 fw-semibold m-0">CSV Lead Management</h4>
                            <p className="fw-semibold my-2">CSV Lead List</p>
                        </div>
                        {userData?.role !== 'employee' && (
                             <div>
                            <button
                                className="btn btn-primary"
                                onClick={() => navigate("/add-csv")}
                                disabled={loading}
                            >
                                <i className="mdi mdi-plus-square me-1"></i>
                                Upload CSV
                            </button>
                        </div>
                            
                        )}
                       
                    </div>

                    <div className="row">
                        <div className="col-12">
                            <div className="card">
                                <div className="card-body">
                                    <form onSubmit={handleSubmit}>
                                        <div className="row g-2 align-items-center">

                                            <div className="col-md-1">
                                                <select
                                                    className="form-select"
                                                    value={rowsPerPage}
                                                    onChange={handleRowsPerPageChange}
                                                >
                                                    <option value={5}>5</option>
                                                    <option value={10}>10</option>
                                                    <option value={25}>25</option>
                                                    <option value={50}>50</option>
                                                    <option value={100}>100</option>
                                                </select>
                                            </div>

                                            <div className="col-md-4">
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    placeholder="Search by name or phone..."
                                                    value={searchTerm}
                                                    onChange={(e) => setSearchTerm(e.target.value)}
                                                />
                                            </div>


                                            <div className="col-md-2">
                                                <input
                                                    type="date"
                                                    className="form-control"
                                                    placeholder="Start Date"
                                                    value={startDate}
                                                    onChange={(e) => setStartDate(e.target.value)}
                                                />
                                            </div>
                                            <div className="col-md-2">
                                                <input
                                                    type="date"
                                                    className="form-control"
                                                    placeholder="End Date"
                                                    value={endDate}
                                                    onChange={(e) => setEndDate(e.target.value)}
                                                />
                                            </div>

                                            <div className="col-md-1">
                                                <button type="submit" className="btn btn-primary w-100">
                                                    <i className="mdi mdi-magnify"></i>
                                                </button>
                                            </div>
                                            <div className="col-md-1">
                                                <button
                                                    type="button"
                                                    className="btn btn-secondary w-100"
                                                    onClick={handleReset}
                                                >
                                                    <i className="mdi mdi-refresh"></i>
                                                </button>
                                            </div>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="row mt-2">
                        <div className="col-12">
                            <div className="card">
                                <div className="card-body">
                                    {loading ? (
                                        <div className="text-center py-5">
                                            <div className="spinner-border text-primary" role="status">
                                                <span className="visually-hidden">Loading...</span>
                                            </div>
                                        </div>
                                    ) : (
                                        <div className="table-responsive">
                                            <table className="table table-hover">
                                                <thead>
                                                    <tr>
                                                        <th>S.No</th>
                                                        <th>Full Name</th>
                                                        <th>Mobile</th>
                                                        <th>Created At</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {csvLeads.length > 0 ? (
                                                        csvLeads.map((lead, index) => (
                                                            <tr key={lead._id}>
                                                                <td>{currentPage * rowsPerPage + index + 1}</td>
                                                                <td>{lead.fullName || '-'}</td>
                                                                <td>
                                                                    {lead.mobile ? (
                                                                        <a
                                                                            href={`tel:${lead.mobile}`}
                                                                            className="text-primary text-decoration-none"
                                                                            title="Click to call"
                                                                        >
                                                                            <i className="mdi mdi-phone me-1"></i>
                                                                            {lead.mobile}
                                                                        </a>
                                                                    ) : (
                                                                        '-'
                                                                    )}
                                                                </td>
                                                                <td>
                                                                    {lead.createdAt ? new Date(lead.createdAt).toLocaleDateString() : '-'}
                                                                </td>
                                                            </tr>
                                                        ))
                                                    ) : (
                                                        !loading && (
                                                            <tr>
                                                                <td colSpan="4" className="text-center py-4">
                                                                    No CSV leads found
                                                                </td>
                                                            </tr>
                                                        )
                                                    )}
                                                </tbody>
                                            </table>

                                            {totalPages > 1 && (
                                                <ReactPaginate
                                                    previousLabel={<i className="mdi mdi-chevron-left"></i>}
                                                    nextLabel={<i className="mdi mdi-chevron-right"></i>}
                                                    breakLabel="..."
                                                    breakClassName="page-item"
                                                    breakLinkClassName="page-link"
                                                    pageCount={totalPages}
                                                    marginPagesDisplayed={2}
                                                    pageRangeDisplayed={5}
                                                    onPageChange={handlePageChange}
                                                    containerClassName="pagination pagination-rounded justify-content-end mt-3"
                                                    pageClassName="page-item"
                                                    pageLinkClassName="page-link"
                                                    previousClassName="page-item"
                                                    previousLinkClassName="page-link"
                                                    nextClassName="page-item"
                                                    nextLinkClassName="page-link"
                                                    activeClassName="active"
                                                    forcePage={currentPage}
                                                />
                                            )}
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default CSVLeadList;